import { Container, Graphics, Sprite } from 'pixi.js';

class SamuraiLayer extends Container {
	layer = null;
	layerGraphics = null;
	constructor() {
		super();
		this.interactiveChildren = false;
		this.cacheAsBitmap = true;

		this.samurailayer = new Sprite();
		this.addChild(this.samurailayer);

		this.samurailayerGraphics = new Graphics();
		this.samurailayer.addChild(this.samurailayerGraphics);
	}

	resize() {
		this.cacheAsBitmap = false;
		this.samurailayerGraphics.clear();
		this.samurailayerGraphics.beginFill(0x000);
		this.samurailayerGraphics.drawRect(
			0,
			0,
			window.CurrentSize.w,
			window.CurrentSize.h
		);
		this.samurailayerGraphics.endFill();
		this.samurailayerGraphics.alpha = 1;

		this.cacheAsBitmap = true;
	}
}

export default SamuraiLayer;
